// extracted by mini-css-extract-plugin
module.exports = {"zoomControlls":"styles_zoomControlls__2Bwjp","zoomOutIcon":"styles_zoomOutIcon__3e15l","zoomInIcon":"styles_zoomInIcon__LGjGe","percentage":"styles_percentage__2q4qp"};